import React, { Component } from "react";
import { Divider, Typography } from "@material-ui/core";
import { withRouter, Redirect } from 'react-router-dom';
import { connect } from "react-redux";
import { 
    putResponse, getQuestion, getQuestionResults, addNote, saveQuizData, submitCME,
    addQuestionToDeck, updateHeaderInfo, putNextReviewDate, syncCMETest,
    getUserDetails, removeQuestion, resetDeck, trackPage, getQuiz, getSASPResidencyProgram, resetQuiz,
    getQuizzes
} from "../actions";
import { QuestionQuizCard, CopyrightWidget, LoadingCard, AILegalStatementCard } from "../components";
import { MessageBannerCard } from "../components/MessageBannerCard";
import { 
    deviceData, setContainer, scrollTop, createMarkup,
    getThisYear, preventCopy, hasLegal,
    removeJSONProp,
    getDayOfYear,
    getQuizTestType,
    DATA_TEXT_ARRAY,
    setLocalStorage,
    getLocalStorage,
    QUIZ_INSTANCE
} from "../common";
import { isBrowser } from 'react-device-detect';

import "../styles/masterStyles.css";
import "../styles/questionStyles.css";

class QuizScreen extends Component {
    state = {
        reload: false,
        copyModal: false,
        text: 'test...',
        loading: true,
        data: null,
        answered: -1,
        type: null,
        typetext: 'Specific Question',
        gamemode: 0,
        year: 0,
        refsMats: null,
        spaced: 0,
        deckid: null,
        prevAnswer: {answered: 0},
        returnhome: 0,
        loadingtext: 'Please wait while we sync your test data.',
        interval: null,
        quiz: null,
        index: 0,
        completed: 0,
        review: false,
        grade: 0,
        showgrade: 0,
        score: 0,
        prevdiv: `QuestionDiv`,
        loaded: false,
        isquiz: 1,
        quizprefix: null, 
        scored: 0,
        instance: QUIZ_INSTANCE(),
    }

    randomtext = () => {
        const arr = DATA_TEXT_ARRAY;
    
        let cnt = 0;
    
        let interval = setInterval(() => {
            const randomIndex = Math.floor(Math.random() * arr.length);
            let t = arr[randomIndex];
            this.setState({ ...this.state, loadingtext : t});
            cnt++;
        }, 3500, cnt);
    
        return this.setState({ ...this.state, interval: interval });
    }

    componentDidMount = async () => {
        this.randomtext();

        const { mcid, key } = this.props.auth_feedback;
        const { availableyears, isResident } = this.props.user_details;
        const { testYear, gameMode, deckID, startindex, completed, year, gamemode } = this.props.location;

        let tracking = deviceData(this.props.location, 'navigate');
        let tobj = {
            mcid: mcid,
            key: key,
            tracking: tracking
        }

        await this.props.trackPage(tobj);

        preventCopy();

        scrollTop('QuestionDiv', -64)
        
        await this.props.updateHeaderInfo({
            name: "", 
            iconTwo: 'menu',
            iconOne: 'home',
        });

        if (isResident && this.props.residentprogram === null) {
            await this.props.getSASPResidencyProgram({ mcid: mcid, key: key })
        }

        let quiz = null;
        let returnhome = 0;
        let index = 0;
        let _completed = completed;
        let isquiz = 1;
        let quizprefix = null;

        if (typeof startindex === 'number') {
            // index = startindex
        }

        let programid = mcid;

        if (this.props.residentprogram !== null) {
        }
        
        let qobj = {
            mcid: mcid,
            key: key,
            programid: programid,
            availableyears: availableyears,
            deckid: deckID,
            gamemode: gameMode,
            // sortorder: 1,
            isquiz: 1
        }

        if (this.props.quiz === null) { await this.props.getQuiz(qobj); }
        else if (this.props.location.deckid !== this.props.quiz.deckid) { await this.props.getQuiz(qobj) } 
        else {
        }
        let _type = 'open';
        let typetext = 'Open Book';

        if (Number(gameMode) === 2 || Number(gameMode) === 4 || Number(gameMode) === 10 || Number(gameMode) === 12) {
            _type = 'closed';
            typetext = 'Closed Book';
        }

        let stateobj = { ...this.state };

        if (quiz !== null && Array.isArray(quiz) === false) {
            stateobj = { 
                ...this.state,
                type: _type,
                gamemode: Number(gameMode),
                deckid: deckID,
                year: testYear,
                typetext: typetext,
                quiz: quiz, 
                returnhome: returnhome,
                index: index,
                completed: _completed,
                isquiz: isquiz,
                quizprefix: quizprefix
            };
        } else {
            stateobj = { 
                ...this.state,
                type: _type,
                gamemode: Number(gameMode),
                deckid: deckID,
                year: testYear,
                typetext: typetext,
                returnhome: returnhome,
                completed: _completed,
                isquiz: isquiz,
                quizprefix: quizprefix
            };
        }

        return this.setState(stateobj)
    };

    componentDidUpdate = async (prevProps, prevState) => {
        if (prevProps.quiz !== this.props.quiz && (typeof this.props.quiz !== 'undefined' && this.props.quiz !== null)) {
            try {
                return this.setState({ ...this.state, quiz: this.props.quiz })
            } catch (e) {
                return this.setState({ ...this.state, quiz: this.props.quiz })
            }
            
        }

        if (prevState.quiz !== this.state.quiz && (typeof this.state.quiz !== 'undefined' && this.state.quiz !== null)) {
            const { testYear, deckID, gameMode } = this.props.location;
            let quizprefix = `sasp_my_quizzes`;
            let thisprop = `_${deckID}`

            if (typeof testYear === 'number') {
                quizprefix = `sasp_my_cme_tests`
                thisprop = `_${testYear}_${gameMode}`;
            }

            // let stringify = JSON.parse(getLocalStorage(quizprefix));
            let stringify = getLocalStorage(quizprefix);
            stringify = JSON.parse(stringify);
            
            try {
                stringify[thisprop] = this.state.quiz;

                // localStorage.setItem(quizprefix, JSON.stringify(stringify));

                setLocalStorage(quizprefix, JSON.stringify(stringify));
            } catch (e) {} 

            let index = this.state.index;

            // index = this.state.quiz[0].startindex;

            if (index >= this.state.quiz.length) { index = (this.state.quiz.length - 1) }

            return this.setState({ ...this.state, data: this.state.quiz[index] })
        }

        if (prevState.data !== this.state.data && this.state.data !== 'undefined') {
            scrollTop('QuestionDiv', -64);

            if (this.state.review && this.state.completed) {
                scrollTop(this.state.prevdiv, -64);
            }

            let index = this.state.index;
            let completed = this.state.completed;

            try {
                // index = this.state.quiz[0].startindex;

                if (index > this.state.quiz.length - 1) {
                    index = this.state.quiz.length - 1;
                    completed = 1;
                }
            } catch (e) {
            }

            clearInterval(this.state.interval);

            let prevAnswer = {answered: 0};
            try {
                prevAnswer = this.getPrevAnswer(this.state.data.qoptions);
            } catch (e) {
            }

            try {
                var _temptext = `${this.state.quiz[0].title}`
            } catch (e) {
                _temptext = '';
            }

            const stateobj = { 
                ...this.state, 
                loading: false, 
                prevAnswer: prevAnswer, 
                text: _temptext,
                completed: completed
            }

            return this.setState(stateobj)
        } else if (prevState.data !== this.state.data && this.state.data === null) {
            return this.setState({ ...this.state, quiz: this.props.quiz })
        }

        if (prevState.index !== this.state.index && this.state.index > 0) {
            scrollTop('QuestionDiv', -64)
            try {
                let index = this.state.index;

                if (index >= this.state.quiz.length) {
                    index = this.state.quiz.length - 1;
                }

                if (index < 0) {
                    index = 0;
                }

                let data = this.state.quiz[index];

                if (typeof data !== 'undefined' && typeof this.state.index !== 'undefined') {
                    return this.setState({ ...this.state, data: data })
                } else {
                }
            } catch (e) {
            }
        }

        if (prevState.completed !== this.state.completed && this.state.completed !== 0) {
            await scrollTop('QuestionDiv', -64);

            return this.setState({ ...this.state, loading: false })
        }

        if ( prevProps.error !== this.props.error && this.props.error !== '' ) {
            let _error = this.props.error;
            let _question = this.props.question;

            if (typeof _error === 'object' || Array.isArray(_error)) {
                try {
                    _error = JSON.stringify(_error);
                } catch (e) {
                }
            }

            if (typeof _question === 'object' || Array.isArray(_error)) {
                try {
                    _question = JSON.stringify(_question);
                } catch (e) {
                }
            }

            const __obj = {
                pathname: 'error',
                prevLoc: {
                    pathname: this.props.location.pathname,
                    detail: _error,
                    detailvar2: _question
                }
            }
            return <Redirect to={__obj} />
        }

        if ( prevState.grade !== this.state.grade ) {
            return this.setState({ ...this.state, showgrade: 1 })
        }
    }

    componentWillUnmount = async () => {
        const { testYear, deckID, gameMode } = this.props.location;
        const {mcid, key} = this.props.user_details;

        try {
            let quizprefix = `sasp_my_quizzes`;
            let thisprop = `_${deckID}`

            if (typeof testYear === 'number') {
                quizprefix = `sasp_my_cme_tests`
                thisprop = `_${testYear}_${gameMode}`;
            }

            let quiz = this.state.quiz;
            let qcnt = 0;
            let index = 0;
            let _completed = 0;
            let trackingindex = 0;

            for (const i of quiz) {
                let q = i.qoptions.filter((item) => {
                    return (item.selected === 1) 
                });

                if (q.length === 0) {
                    break;
                } else {
                }
                

                qcnt += q.length;

                index = qcnt;

                if (index >= quiz.length) {
                    index = quiz.length - 1;
                    _completed = 1;
                }

                trackingindex++;
            }

            quiz[0].startindex = index;
            quiz[0].percompleted = Number((index / quiz.length) * 100)

            let stringify = JSON.parse(getLocalStorage(quizprefix));
            stringify[thisprop] = quiz;

            // localStorage.setItem(quizprefix, JSON.stringify(stringify));
            await setLocalStorage(quizprefix, JSON.stringify(stringify));

        } catch (e) {
        }

        const pobj = {
            mcid: mcid,
            key: key,
            programid: mcid,
            availableyears: this.props.user_details.authorizedyears
        }

        // await this.props.getQuizzes(pobj);
    }

    getPrevAnswer = (obj) => {
        let r = {
            answered: 0.,
            index: -1
        }

        let cnt = 0;
        try {
            for (const i of obj) {
                if (i.selected === 1) {
                    r.index = cnt;
                    r.answered = 1;
                    break;
                }
                cnt++;
            }
        } catch (e) {

        }

        return r;
    }

    handleOpen = () => {
        this.setState({
            ...this.state,
            copyModal: true,
        });
    };

    handleClose = () => {
        this.setState({
            ...this.state,
            copyModal: false,
        });
    };

    setColorObj = (type = 'base') => {
        let r;

        switch (type) {
            default: {
                r = {
                    deck: "neutralGreenCard",
                    text: "neutralGreenText",
                    button: "neutralGreenCard"
                }
            }
        }
        return r;
    }

    handleSubmit = async (obj) => {
        this.setState({ ...this.state, loading: true, loadingtext: 'Please wait while we sync your test data.' })

        let temp = this.state.data;
        let myanswers = 0;

        for (const i of temp.qoptions) {
            if (i.AnswerOptionID === obj.answerid) {
                i.selected = 1;
                // break;
            } else {
                i.selected = 0;
            }
        }

        let tquiz = this.state.quiz;

        let i = this.state.index;
        if (i >= tquiz.length) {
            i = tquiz.length - 1;
        } else if (i < 0) {
            i = 0
        }

        tquiz[i] = temp;

        let _1pos = tquiz[0];

        // _1pos.startindex = i + 1;
        _1pos.percompleted = Number((_1pos.startindex / tquiz.length) * 100);

        tquiz[0] = _1pos;

        const { mcid, key, token } = this.props.auth_feedback
        const { testYear, deckID, gameMode } = this.props.location;
        let quizprefix = `sasp_my_quizzes`;
        let thisprop = `_${deckID}`

        if (typeof testYear === 'number') {
            quizprefix = `sasp_my_cme_tests`
            thisprop = `_${testYear}_${gameMode}`;
        }

        // let stringify = JSON.parse(getLocalStorage(quizprefix));
        let stringify = JSON.parse(getLocalStorage(quizprefix));

        stringify[thisprop] = tquiz;

        setLocalStorage(quizprefix, JSON.stringify(stringify))

        // localStorage.setItem(quizprefix, JSON.stringify(stringify));

        switch (this.state.gamemode) {
            case 1:
            case 3:
            case 9:
            case 11: {
                await this.setState({
                    ...this.state,
                    answered: 1,
                    data: temp,
                    quiz: tquiz
                });
                break;
            }
            case 2:
            case 4:
            case 10:
            case 12: {
                await this.setState({
                    ...this.state,
                    answered: -1,
                    data: temp,
                    quiz: tquiz
                });
                break;
            }
        }

        let completed = this.state.review;

        for (const ans of tquiz) {
            for (const i of ans.qoptions ) {
                myanswers += i.selected;
            }
        }

        if (myanswers >= tquiz.length) {
            completed = 1;
        } else {
            completed = 0;
        }

        obj.__myanswers = myanswers;
        obj.__completed = completed

        if (typeof obj.next !== 'undefined' && obj.next !== null) {
            i++;
            if (i >= tquiz.length) {
                i = tquiz.length - 1;
                completed = 1;
            } else if (i < 0) {
                i = 0
            }

            const select = temp.qoptions.find((item) => { return item.selected === 1 });

            let subtracking = deviceData(this.props.location, 'submit answer');
            subtracking.action = 'answer question';

            const data = {
                mcid: mcid,
                key: key,
                questionID: temp.questionID,
                gamemode: gameMode,
                optionSelected: select.AnswerOptionID,
                deckID: temp.deckid,
                instance: this.state.instance,
                token: token,
                tracking: subtracking,
            };

            this.setState({ ...this.state, loading: true });
            await this.props.putResponse(data);      

            const robj = { ...this.state, answered: -1, index: i, completed: completed, loading: false };
            return this.setState(robj)
        }

        if (typeof obj.prev !== 'undefined') {
            i--;
            if (i >= tquiz.length) {
                i = tquiz.length - 1;
                // completed = 0;
            } else if (i < 0) {
                i = 0
            }

            const robj = { ...this.state, answered: -1, index: i, completed: completed };
            return this.setState(robj)
        }

        return null;
    }

    handleSelected = async (obj) => {
        // return null;
        const temp = this.state.data;

        for (const i of temp.qoptions) {
            if (i.AnswerOptionID === obj.id) {
                i.selected = 1;
                break;
            } else {
                i.selected = 0;
            }
        }

        let tquiz = this.state.quiz;

        let index = this.state.index;

        if (index >= tquiz.length) {
            index = tquiz.length;
        } else if (index < 0) {
            index = 0
        }

        tquiz[index] = temp;

        let _1pos = tquiz[0];

        // _1pos.startindex = index + 1;
        _1pos.percompleted = Number((_1pos.startindex / tquiz.length) * 100);

        tquiz[0] = _1pos;

        const { testYear, deckID, gameMode } = this.props.location;
        let quizprefix = `sasp_my_quizzes`;
        let thisprop = `_${deckID}`

        if (typeof testYear === 'number') {
            quizprefix = `sasp_my_cme_tests`
            thisprop = `_${testYear}_${gameMode}`;
        }

        let stringify = JSON.parse(getLocalStorage(quizprefix));

        // let stringify = JSON.parse(getLocalStorage(quizprefix));

        stringify[thisprop] = tquiz;

        // setLocalStorage(quizprefix, JSON.stringify(stringify));

        // localStorage.setItem(quizprefix, JSON.stringify(stringify));

        switch (this.state.gamemode) {
            default: {
                this.setState({
                    ...this.state,
                    data: temp,
                    quiz: tquiz,
                });
                break;
            }
        }
        
        return null;
    }

    addNote = async (data) => {
        data.questionID = Number(data.questionID);
        this.props.addNote(data);
    }

    addToDecks = async (id, deckID) => {
        let cnt = 0;
        let obj;
        if (!deckID) {
            for (const i in this.props.deckList) {
                obj = {
                    mcid: this.props.auth_feedback.mcid,
                    key: this.props.auth_feedback.key,
                    questionID: id, 
                    deckID: this.props.deckList[i].deckID
                };

                this.props.addQuestionToDeck(obj);
                cnt++
            }
        } else {
            obj = {
                mcid: this.props.auth_feedback.mcid,
                key: this.props.auth_feedback.key,
                questionID: id, 
                deckID: deckID
            };

            this.props.addQuestionToDeck(obj);
        }        
    }

    removeQuestion = async(obj) => {
        return this.props.removeQuestion(obj);
    }

    scrollToTop = () => {
        return scrollTop('QuestionDiv', -64);
    }

    _reset = async (obj) => {
        let _path;
        if (typeof obj.deckid !== 'undefined') {
            _path = {
                mcid: this.props.user_details.mcid,
                key: this.props.user_details.key,
                next: 0
            };
        } else {
            _path = {
                mcid: this.props.user_details.mcid,
                key: this.props.user_details.key,
                next: 0
            };
        }

        await this.props.resetDeck(obj);

        return this.handleSubmit(_path)
    }

    nextFunc = (index) => {
        let next = index + 1;
        let completed = 0;

        if (next >= this.state.quiz.length) {
            next = this.state.quiz.length - 1;
            completed = 1;
        }

        return this.setState({
            ...this.state,
            index: next,
            completed: completed,
            data: this.state.quiz[next]
        })
    }

    prevFunc = (index) => {
        let next = index - 1;

        if (next < 0) {
            next = 0;
        }

        return this.setState({
            ...this.state,
            index: next,
            data: this.state.quiz[next]
        })
    }

    handleReview = (bool) => {
        return this.setState({ ...this.state, completed: bool, answered: -1 })
    }

    submitForScoring = async (bool) => {
        if (typeof bool !== 'boolean') { bool = false }
        await this.setState({ ...this.state, loading: true, loadingtext: 'Preparing Submition' })
        const quiz = this.state.quiz;
        const {mcid, key, token} = this.props.auth_feedback;
        const {gameMode, deckID, testYear} = this.props.location;

        let index = 1;
        let grade, score = 0;
        let questionidstr = '';

        const total = quiz.length;

        for (const i of quiz) {
            let tracking = deviceData(this.props.location, 'submit answer')
            tracking.action = 'quiz answer';

            const select = i.qoptions.find((item) => { return item.selected === 1 });
            const data = {
                mcid: mcid,
                key: key,
                questionID: i.questionID,
                gamemode: gameMode,
                optionSelected: select.AnswerOptionID,
                deckID: i.deckid,
                token: token
            };

            if (questionidstr.length === 0) {
                questionidstr = i.questionID;
            } else {
                questionidstr += `,${i.questionID}`;
            }

            if (Number(select.AnswerOptionCorrect) === 1 ) {
                ++score;
            }

            await this.setState({ ...this.state, loadingtext: `Grading Question ${index++}`});
        }

        if (index > quiz.length) {
            const obj = {
                mcid: mcid,
                key: key,
                gameMode: gameMode,
                deckID: deckID,
                token: token
            }

            grade = (score / total) * 100;
            grade = grade.toFixed(1);

            let tracking = deviceData(this.props.location, 'save quiz');
            tracking.action = 'completed quiz'

            let saved = {
                mcid: mcid,
                key: key,
                token: token,
                deckID: deckID,
                gamemode: gameMode,
                questionidstr: questionidstr,
                grade: grade,
                score: score,
                totalquestions: total,
                tracking: tracking
            }

            await this.props.saveQuizData(saved);
            await this.setState({ ...this.state, loadingtext: `Finalizing Grading...`});

            let quizprefix = `sasp_my_quizzes`;
            let thisprop = `_${deckID}`

            if (typeof testYear === 'number') {
                quizprefix = `sasp_my_cme_tests`
                thisprop = `_${testYear}_${gameMode}`;
            }

            let myquizzes = JSON.parse(getLocalStorage(quizprefix));
            let quizprop = myquizzes[thisprop];

            // for (const i of quizprop) {
            //     for (const x of i.qoptions) {
            //         x.selected = 0;
            //     }
            // }

            // quizprop[0].startindex = 0;
            // quizprop[0].percompleted = 0;

            quizprop[0].scored = 1;

            myquizzes[thisprop] = quizprop;

            setLocalStorage(quizprefix, JSON.stringify(myquizzes));

            // await this.props.resetDeck(obj);

            return this.setState({ ...this.state, loading: bool, grade: grade, score: score, scored: 1 })
        }
    }

    resetTest = async () => {
        await this.setState({ ...this.state, loading: true, loadingtext: 'Resetting Quiz' })
        const quiz = this.state.quiz;
        const {mcid, key, token} = this.props.auth_feedback;
        const {gameMode, deckID, testYear} = this.props.location;

        const obj = {
            mcid: mcid,
            key: key,
            gameMode: gameMode,
            deckID: deckID,
            token: token
        }

        let quizprefix = `sasp_my_quizzes`;
        let thisprop = `_${deckID}`

        if (typeof testYear === 'number') {
            quizprefix = `sasp_my_cme_tests`
            thisprop = `_${testYear}_${gameMode}`;
        }

        let myquizzes = JSON.parse(getLocalStorage(quizprefix));
        let quizprop = myquizzes[thisprop];

        for (const i of quizprop) {
            for (const x of i.qoptions) {
                x.selected = 0;
            }
        }

        quizprop[0].startindex = 0;
        quizprop[0].percompleted = 0;
        
        delete quizprop[0].scored;

        myquizzes[thisprop] = null;

        setLocalStorage(quizprefix, JSON.stringify(myquizzes));

        await this.props.resetDeck(obj);
        await this.props.resetQuiz();

        return this.setState({ ...this.state, returnhome: 1 });
    }

    syncTest = async () => {
        await this.setState({ ...this.state, loading: true, loadingtext: 'Preparing Submition' })
        const {mcid, key, token} = this.props.auth_feedback;
        const {gameMode, deckID, testYear} = this.props.location;
        const {availableyears} = this.props.user_details;

        const dobj = {
            mcid: mcid,
            key: key,
            gamemode: gameMode,
            deckid: deckID,
            year: testYear,
            availableyears: availableyears
        }
    }

    submitForCME = async () => {
        await this.setState({ ...this.state, loading: true });

        const {mcid, key, token} = this.props.auth_feedback;
        const {gameMode, deckID, testYear} = this.props.location;

        await this.submitForScoring(true);

        const sobj = {
            mcid: mcid, 
            key: key,
            gamemode: gameMode,
            qyear: testYear
        };

        await this.props.submitCME(sobj, deviceData(this.props.location, 'claim cme'));
        await this.resetTest();

        return this.setState({ ...this.state, loading: false, returnhome: 1 });
    }

    render() {
        if (this.state.returnhome) {
            const robj = {
                pathname: '/quizResultScreen',
                state: { 
                    instance: this.state.instance,
                    deckid: this.state.deckid, 
                    gamemode: this.state.gamemode
                }
            }
            return <Redirect to={robj} />
        } else if (this.state.loading || this.state.data === null) {
            return (
                <LoadingCard textarray={this.state.loadingtext}/>
            )
        } else if (this.state.completed) {
            let gradeobj = { title: `Quiz Filler`, text: ``, summary: `<p>Filler</p>`, messageday: getDayOfYear(), messageday: getDayOfYear()}
            if (this.state.showgrade) {
                gradeobj = {
                    title: 'Quiz Summary',
                    text: ``,
                    summary: `<p>You have answered <strong>${this.state.score}</strong> out of <strong>${this.state.quiz.length}</strong> questions correct scoring <strong>${this.state.grade}%</strong>.</p><p>You may take this quiz again.</p> <p>Each time to take this quiz questions will be randomly selected from the pool of available questions.</p>`,
                    messageid: getDayOfYear(),
                    messageday: getDayOfYear()
                }
            }

            let error = 0;
            return(
                <>
                    <AILegalStatementCard in={hasLegal()} />
                    {this.state.showgrade
                        ? (
                            <MessageBannerCard data={gradeobj} />
                        ) : null
                    }
                    <div className=" aua-overflow" id="QuestionDiv">
                        <Typography className="homeDividerText">{this.state.text}</Typography>

                        <div className="question-container" >
                            <section className="margin-bottom-8">
                                <p>Review your Quiz before you submit for scoring: </p>
                            </section>

                            <section className="margin-bottom-16">
                                <>
                                    {this.state.quiz.map((item, index) => {
                                        try {
                                            let answer = '';
                                            let correct = '';
                                            let correctclass = ''

                                            let tanswer = item.qoptions.find((i) => {
                                                return i.selected === 1
                                            })

                                            let canswer = item.qoptions.find((i) => {
                                                return i.AnswerOptionCorrect === 1
                                            })

                                            if (
                                                tanswer.selected === canswer.selected && 
                                                (Number(this.props.location.gameMode) === 1 || Number(this.props.location.gameMode) === 9 || Number(this.props.location.gameMode) === 11)) 
                                            {
                                                correctclass   = ' correctanswer';
                                            } else if (
                                                tanswer.selected !== canswer.selected && 
                                                (Number(this.props.location.gameMode) === 1 || Number(this.props.location.gameMode) === 9 || Number(this.props.location.gameMode) === 11)) 
                                            {
                                                correctclass   = ' incorrectanswer';
                                            }

                                            if (tanswer !== null && typeof tanswer === 'object') {
                                                try {
                                                    answer = `<p className="${correctclass}"><span style={{marginRight: '8px'}}>${tanswer.AnswerOptionLetter}:</span> ${tanswer.AnswerOption}</p>`
                                                } catch (e) {}
                                            }

                                            if (canswer !== null && typeof canswer === 'object') {
                                                try {
                                                    correct = `<p className="correctanswer"><span style={{marginRight: '8px'}}>${canswer.AnswerOptionLetter}:</span> ${canswer.AnswerOption}</p>`
                                                } catch (e) {}
                                            }
                                            
                                            return (
                                                <div className="review-quiz-card " id={`question-div-${index}`}>
                                                    <div className="margin-bottom-4">
                                                        <strong>Question {index + 1}: SASP {item.QuestionYear} Question {item.questionNumber}</strong>
                                                    </div>
                                                    <div className="margin-bottom-8 text-legal" dangerouslySetInnerHTML={createMarkup(item.questionText)} />

                                                    
                                                    <div className="margin-bottom-4">
                                                        <strong>Explanation</strong>
                                                    </div>
                                                    
                                                    <div className="margin-bottom-8 text-legal" dangerouslySetInnerHTML={createMarkup(item.explanation)} />
                                                           
                                                            
                                                    <div className="margin-bottom-4">
                                                        <strong>Your Answer</strong>
                                                    </div>

                                                    <div className="margin-bottom-8" dangerouslySetInnerHTML={createMarkup(answer)} />

                                                    
                                                    <div className="margin-bottom-4">
                                                        <strong>Correct Answer</strong>
                                                    </div>

                                                    <div className="margin-bottom-8" dangerouslySetInnerHTML={createMarkup(correct)} />
                                                        
                                                    <div>
                                                        <div 
                                                            className="sasp-review-btn"
                                                            onClick={() => {
                                                                let obj = {
                                                                    ...this.state,
                                                                    index: index,
                                                                    completed: 0,
                                                                    review: true,
                                                                    prevdiv: `question-div-${index}`
                                                                }

                                                                return this.setState(obj);
                                                            }}
                                                        >
                                                            Review Question
                                                        </div>
                                                    </div>
                                                </div>
                                            )
                                        } catch (e) {
                                            const answer = `<p><strong>You have not answered Question ${index + 1}</strong>.</p></p>You must answer this question before you submit this quiz for grading.</p>`
                                            
                                            if (!error) {
                                                error = index - 1;
                                                
                                                if (error < 0) error = 0;

                                                scrollTop(`error-div-${error}`, -64);
                                            }
                                            
                                            return (
                                                <div className="review-quiz-card error" id={`question-div-${index}`}>
                                                    <div className="margin-bottom-4">
                                                        <strong>Question {index + 1}: SASP {item.QuestionYear} Question {item.questionNumber}</strong>
                                                    </div>
                                                    <div className="margin-bottom-4 text-legal" dangerouslySetInnerHTML={createMarkup(item.questionText)} />

                                                    <div className="margin-bottom-8" dangerouslySetInnerHTML={createMarkup(answer)} />
                                                        
                                                    <div>
                                                        <div 
                                                            className="sasp-review-btn unanswered"
                                                            onClick={() => {
                                                                let obj = {
                                                                    ...this.state,
                                                                    index: index,
                                                                    completed: 0,
                                                                    review: true
                                                                }

                                                                return this.setState(obj);
                                                            }}
                                                        >
                                                            Answer Question
                                                        </div>
                                                    </div>
                                                </div>
                                            )
                                        }
                                    })}
                                </>
                            </section>

                            {!error || !this.state.score 
                                ? (
                                    <section className="margin-bottom-64 width100" style={{display:'flex', flexDirection: 'row', justifyContent: 'space-between'}}>
                                        <div 
                                            className="sasp-review-btn-quiz"
                                            onClick={() => {
                                                return this.resetTest();
                                            }}
                                        >
                                            Submit Quiz
                                        </div>

                                        {Number(this.props.location.gameMode) < 3
                                            ? (
                                                <div 
                                                    className="sasp-review-btn-quiz cme-btn"
                                                    onClick={() => {
                                                        return this.submitForScoring();
                                                    }}
                                                >
                                                    Submit For CME
                                                </div>
                                            ) : null
                                        }
                                    </section>
                                ) : (
                                    <section className="margin-bottom-64 width100" style={{display:'flex', flexDirection: 'row', justifyContent: 'space-between'}}>
                                        <div 
                                            className="sasp-review-btn-quiz"
                                            onClick={() => {
                                                return this.resetTest();
                                            }}
                                        >
                                            Reset Quiz
                                        </div>
                                    </section>
                                )
                            }

                            <CopyrightWidget 
                                year={getThisYear()}
                                textAlign={'center'}
                                className="margin-top-8 padding-top-8 padding-bottom-24 padding-left-16 padding-right-16"
                            />
                        </div>
                    </div>
                </>
            )
        } else {
            return (
                <>
                    <AILegalStatementCard in={hasLegal()} />
                    <div className=" aua-overflow" id="QuestionDiv">
                        <Typography className="homeDividerText">{this.state.text} Question {(this.state.index + 1)} / {this.state.quiz.length}</Typography>

                        <div className="question-container" >
                            {(typeof this.state.data !== 'undefined' && this.state.data !== null && typeof this.state.data.active !== 'undefined') && ( typeof this.state.data.active !== 'undefined' && this.state.data.active === 1)
                                ? (
                                    <>
                                        <QuestionQuizCard   
                                            prevAnswer={this.state.prevAnswer}
                                            obj={this.state.data}
                                            text={this.state.text}
                                            answered={this.state.answered}
                                            type={this.state.type}
                                            typetext={this.state.typetext}
                                            spaced={this.state.spaced}
                                            gamemode={this.state.gamemode}
                                            year={this.state.year}
                                            deckid={this.state.deckid}
                                            submitFunc={this.handleSubmit}
                                            selectFunc={this.handleSelected}
                                            nextFunc={this.nextFunc}
                                            backFunc={this.prevFunc}
                                            mykey={this.props.user_details.key}
                                            mcid={this.props.user_details.mcid}
                                            addNote={this.addNote}
                                            addToDecks={this.addToDecks}
                                            removeQuestion={this.removeQuestion}
                                            putNextReviewDate={this.props.putNextReviewDate}
                                            scrollToTop={this.scrollToTop}
                                            refsMats={this.state.refsMats}
                                            labs={this.props.user_details.labstest}
                                            deckList={this.props.deckList ? this.props.deckList : []}
                                            quizzes={this.props.quizzes ? this.props.quizzes : [] }
                                            id={'QuestionDiv'}
                                            resetTest={this.resetTest}
                                            syncTests={this.syncTest}
                                            quiz={this.state.quiz}
                                            index={this.state.index ? this.state.index : 0}
                                            review={this.state.review}
                                            handleReview={this.handleReview}
                                            isstaff={this.props.user_details.isstaff}
                                        />

                                        <CopyrightWidget 
                                            year={getThisYear()}
                                            textAlign={'center'}
                                            className="margin-top-8 padding-top-8 padding-bottom-24 padding-left-16 padding-right-16"
                                        />
                                    </>
                                )
                                : (
                                    <LoadingCard text={'Finalizing Setup'}/>
                                )
                            }
                        </div>
                    </div>
                </>
            );
        }
    }
}

const mapStateToProps = state => {
    const { auth_feedback, user_details, residentprogram } = state.auth;
    const { headerText, iconOne, iconTwo, backgroundcolor } = state.style;
    const { flashCards, deckList, quizzes, quiz } = state.decks;
    const { question, error } = state.question;

    return {
        headerText,
        iconOne,
        iconTwo,
        backgroundcolor,
        flashCards,
        auth_feedback,
        user_details,
        question, 
        deckList,
        error, 
        quizzes,
        quiz,
        residentprogram
    };
};

export default connect(mapStateToProps, 
    { 
        putResponse, getQuestion, getQuestionResults, addQuestionToDeck, updateHeaderInfo, putNextReviewDate, addNote, getUserDetails, removeQuestion, resetDeck, trackPage, getQuiz, saveQuizData, syncCMETest, getSASPResidencyProgram, submitCME, resetQuiz, getQuizzes
    })(withRouter(QuizScreen));

// export { QuizScreen};
